import { type ClassValue, clsx } from 'clsx';
import { useEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';

export function titleAnchor(str: string): string {
  return str
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function useDebounceWithLoading<T>(value: T, delay = 300): { debouncedValue: T; isLoading: boolean } {
  const [debouncedValue, setDebouncedValue] = useState(value);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    const timer = setTimeout(() => {
      setDebouncedValue(value);
      setIsLoading(false);
    }, delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return { debouncedValue, isLoading };
}

// Removed mapItemTypeToContentType function as it's no longer needed
// Content types are now derived from contentIds in the backend
